<template>
  <gmap-marker
    :position="{ lat: dealer.latitude, lng: dealer.longitude }"
    :clickable="true"
    :title="dealer.name1"
    :icon="icon"
    @click="clickMarker"
  />
</template>

<script>
import { googleIsLoaded } from '../tools';
import icons from '../icons';

export default {
  props: {
    dealer: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      normalSize: null,
      activeSize: null,
    };
  },

  computed: {
    icon() {
      if (this.isActive) {
        return {
          url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(
            icons.mapPinFilled,
          )}`,
          scaledSize: this.activeSize,
          anchor: { x: 14.5, y: 40 },
        };
      }

      return {
        url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(icons.mapPin)}`,
        scaledSize: this.normalSize,
        anchor: { x: 15, y: 40 },
      };
    },
  },

  mounted() {
    googleIsLoaded().then(() => {
      this.$nextTick(() => {
        this.normalSize = new google.maps.Size(30, 40);
        this.activeSize = new google.maps.Size(30, 40);
      });
    });
  },

  methods: {
    clickMarker() {
      if (this.isActive) {
        this.$emit('closeInfoWindow');
      } else {
        setTimeout(() => {
          this.$emit('setActiveDealer', this.dealer);
        }, 100);
      }
    },
  },
};
</script>
